import { useEffect, useState } from "react";
import "./AircraftPhoto.css";

export default function AircraftPhoto({ icao }) {
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (!icao) return;
    const controller = new AbortController();
    setPhoto(null);

    (async () => {
      try {
        const res = await fetch(`/api/photo/${icao}`, { signal: controller.signal });
        if (!res.ok) return;
        const data = await res.json();
        if (data?.photo?.url) setPhoto(data.photo);
      } catch {
        // aborted or network error — render nothing
      }
    })();

    return () => controller.abort();
  }, [icao]);

  if (!photo) return null;

  return (
    <div className="aircraft-photo">
      <img src={photo.url} alt="Photo of the aircraft" loading="lazy" />
      <p className="photo-credit">
        Photo © {photo.photographer || "Unknown"} ·{" "}
        <a href={photo.link} target="_blank" rel="noopener noreferrer">
          Planespotters.net
        </a>
      </p>
    </div>
  );
}
